import { t, useTolgeeUpdates } from 'i18n';
import { FC, useCallback } from 'react';
import { MoonIcon } from './icons/Moon';
import { SunIcon } from './icons/Sun';
import { tTheme } from './themeConfig';
import { useColorTheme } from './useColorTheme';

export interface IThemeOption {
  value: tTheme;
  label: string;
  Icon: FC;
}

interface IThemeToggle {
  options: IThemeOption[];
  lightLabel: string;
  CurrentIcon: FC;
  setLight: (enabled: boolean) => void;
}

const THEME_ICON: Record<tTheme, FC> = { light: SunIcon, dark: MoonIcon };

/** Shared by the profile-menu appearance switch and the settings theme row. */
export const useThemeToggle = (): IThemeToggle => {
  const { theme, switchTheme } = useColorTheme();

  useTolgeeUpdates();

  const light = t('frontend.member.settings.pages.sound_and_visual.light_theme', {
    defaultValue: 'Light theme'
  });
  const dark = t('frontend.member.settings.pages.sound_and_visual.dark_theme', {
    defaultValue: 'Dark theme'
  });
  const options: IThemeOption[] = [
    { value: 'light', label: light, Icon: THEME_ICON.light },
    { value: 'dark', label: dark, Icon: THEME_ICON.dark }
  ];

  const setLight = useCallback(
    (enabled: boolean) => switchTheme(enabled ? 'light' : 'dark'),
    [switchTheme]
  );

  return { options, lightLabel: light, CurrentIcon: THEME_ICON[theme], setLight };
};
